import { Component, OnInit, Inject, Input } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Invitation, InvitationType, Learnspace } from '@shared/models';
import { CoursesAPIService } from '@shared/services/coursesApi.service';
import { AuthenticationService } from '@shared/services/authentication.service';

@Component({
  selector: 'learnspace-requestaccess-dialog',
  templateUrl: './learnspace-requestaccess-dialog.component.html',
  styleUrls: ['./learnspace-requestaccess-dialog.component.scss']
})
export class LearnspaceRequestAccessComponent implements OnInit {

  learnspace: Learnspace;
  public message: string;
  constructor(
    public _dialogRef: MatDialogRef<LearnspaceRequestAccessComponent>,
    private _courseApiService: CoursesAPIService,
    private _dialog: MatDialog,
    private _authService: AuthenticationService,
    @Inject(MAT_DIALOG_DATA) public _data: { learnspace: Learnspace }
  ) {

  }

  ngOnInit(): void {
    this.learnspace = this._data.learnspace;
  }
  requestLearnspaceAccess(): void {
    this._authService.getWondaUser().then(user => {
      const invitation = new Invitation(user.id, this.learnspace.owner.email, this.learnspace.id, InvitationType.requestAccessLearnspace, {}, this.learnspace.owner.id);
      this._courseApiService.createInvitation(invitation).subscribe(res => {
        this.message = `An access request has been sent to ${this.learnspace.owner.first_name} ${(this.learnspace.owner.last_name) ? this.learnspace.owner.last_name : ''}`;
      });
    });
  }

  getOwnerName(): string {
    if (this.learnspace.owner.last_name) {
      return `${this.learnspace.owner.first_name} ${this.learnspace.owner.last_name}`;
    }
    return this.learnspace.owner.first_name;
  }
}

